// Local
import Animate from './partials/animate';
import UploadControl from "./partials/upload-control";
import FieldsetRepeatable from "./partials/fieldset-repeatable";
import Navigation from "./partials/navigation";
import CampFilters from "./partials/camp-filters";
import CampBookingForm from "./partials/camp-booking-form";
import MyCosmoMenu from "./partials/my-cosmo-menu";
import MyCosmoFinalizeTrial from "./partials/my-cosmo-finalize-trial";
import MyCosmoChildDelete from "./partials/my-cosmo-child-delete";
import PrintPage from "./partials/print-page";

window.initDom = ($wrapper) => {
    console.debug($wrapper, 'init');
    $wrapper.querySelectorAll('[data-site-header]').forEach($el => new Navigation($el));
    $wrapper.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
    $wrapper.querySelectorAll('[data-upload]').forEach($el => new UploadControl($el));
    $wrapper.querySelectorAll('[data-form-repeatable]').forEach($el => new FieldsetRepeatable($el));
    $wrapper.querySelectorAll('[data-camp-filters]').forEach($el => new CampFilters($el));
    $wrapper.querySelectorAll('[data-camp-booking-form]').forEach($el => new CampBookingForm($el));
    $wrapper.querySelectorAll('[data-my-cosmo-sidebar]').forEach($el => new MyCosmoMenu($el));
    $wrapper.querySelectorAll('[data-my-cosmo-finalize-dialog]').forEach($el => new MyCosmoFinalizeTrial($el));
    $wrapper.querySelectorAll('[data-my-cosmo-child-delete-dialog]').forEach($el => new MyCosmoChildDelete($el));
    $wrapper.querySelectorAll('[data-print-page]').forEach($el => new PrintPage($el));
    applyMediaFocalPoints($wrapper);
    $wrapper.querySelectorAll('[data-form]').forEach(async ($el) => {
        const Form = await import('./partials/form');
        (new Form.default($el));
    });
}

(function() {
    window.initDom(document);
})();

function applyMediaFocalPoints($wrapper) {
    const selector = '[data-focal-position], [data-background-image]';
    const $items = [];

    if ($wrapper.matches && $wrapper.matches(selector)) {
        $items.push($wrapper);
    }

    $items.push(...$wrapper.querySelectorAll(selector));

    $items.forEach($el => {
        const focalPosition = $el.getAttribute('data-focal-position');
        const focalProperty = $el.getAttribute('data-focal-property') || 'object-position';
        const backgroundImage = $el.getAttribute('data-background-image');

        if (backgroundImage) {
            $el.style.backgroundImage = `url("${backgroundImage.replace(/"/g, '\\"')}")`;
        }

        if (!focalPosition) {
            return;
        }

        if (focalProperty === 'background-position') {
            $el.style.backgroundPosition = focalPosition;
            return;
        }

        $el.style.objectPosition = focalPosition;
    });
}
